import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const fb = 'https://www.facebook.com/csqgroup/';

export default new Vuex.Store({
  state: {
    mobile: false,
    drawer: false,
    name: {
      zh: '社團法人中華服務品質發展協會',
      en: 'Chinese Service Quality Development Association',
    },
    fb: fb,
    routers: [
      { title: '首頁', to: { name: 'Home' } },
      { title: '好文推薦', to: { name: 'Post', params: { type: null } } },
      { title: '關於協會', to: { name: 'About' } },
      { title: '聯絡我們', to: { name: 'Contact' } },
      { title: 'Article', to: { name: 'Article' }, disabled: true },
    ],
  },
  mutations: {
    isMobile: (state, boolen) => {
      state.mobile = boolen;
    },
    showDrawer: (state, boolen) => {
      state.drawer = boolen;
    },
  },
  actions: {
  },
  modules: {
  }
})
